import { IconButton, Stack, Badge, Popover, Box, InputBase } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";
import MessageError from '../messages/messageError';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
// import { useSelector } from "react-redux";
import LoadingShort from '../load/loadingShort';
import api from "../services/api";

export default function EmpresaFilter({ setEmpresas, setLoading }) {
  // const user = useSelector((state) => state.account.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [valor, setValor] = useState('');
  const [load, setLoad] = useState(false);
  const [messageError, setMessageError] = useState('');

  const onClose = () => {
    setAnchorEl(null);
    setMessageError('');
  }; 


  const search = async (e) => {
    e.preventDefault()
    setMessageError('')
    setLoad(true)
    setLoading(true)
    setEmpresas([])

    try {
      const response = await api.post(`/empresa/search`, { search: valor });
      setLoad(false)
      setLoading(false)
      // console.log(response)
      setEmpresas(response.data.empresas)

    } catch (error) {
      setLoad(false)
      setLoading(false)
      // console.log(error)
      setMessageError(error.response.data.message);
    }
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!valor}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>

          {messageError && <MessageError message={messageError} />}

          <form onSubmit={search} style={{ display: 'flex', }}>
            <InputBase
              required
              autoFocus
              style={{ maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Filtrar"
              defaultValue={valor}
              onChange={(e) => setValor(e.target.value)}
            />
            <IconButton type="submiy" aria-label="search">
              {load ? <LoadingShort /> : <PersonSearchIcon />}
            </IconButton>
          </form>
        </Box>
      </Popover>
    </Stack>
  );
};


